export const AuraToastPositions = {
    top: 1,
    topleft: 2,
    topright: 3,
    bottom: 4,
    bottomleft: 5,
    bottomright: 6,
};
